// Time units
export const DAYS_IN_MONTH = 30.42
export const HOURS_IN_DAY = 24

// Media capacity units
export const MB_IN_GB = 1024

// Currency
export const KOPECKS_IN_RUBLE = 100